// extracted by mini-css-extract-plugin
export var blue = "_49-h";
export var brand = "_49-d";
export var darkGrey = "_49-g";
export var disabled = "_49-6";
export var disabledSubtle = "_49-7";
export var error = "_49-8";
export var green = "_49-i";
export var grey = "_49-f";
export var icon = "_49-0";
export var inherit = "_49-c";
export var lightGrey = "_49-e";
export var orange = "_49-k";
export var pink = "_49-m";
export var primary = "_49-1";
export var purple = "_49-n";
export var quaternary = "_49-4";
export var quinary = "_49-5";
export var red = "_49-l";
export var secondary = "_49-2";
export var success = "_49-b";
export var tertiary = "_49-3";
export var warning = "_49-9";
export var warningSecondary = "_49-a";
export var white = "_49-o";
export var yellow = "_49-j";